import request from "@/axios.js";


export default class ScreamingFrog {


	constructor(purchase) {


	}
    /**
     * Get the issues of a prospect
     * @param {Int} id 
     * @returns 
     */
	static async getIssuesByProspectId(id){
        return new Promise((resolve, reject) => {
            request.get("/prospect/issuesByProspect/"+ id)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
	}
    /**
     * Get the issues of a prospect
     * @param {Int} id 
     * @returns 
     */
	static async internalTabsByProspect(id){
        return new Promise((resolve, reject) => {
            request.get("/prospect/internalTabsByProspect/"+ id)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
	}

	
}
